import { render, staticRenderFns } from "./NormalItem.vue?vue&type=template&id=e05c2a68"
import script from "./NormalItem.vue?vue&type=script&lang=ts"
export * from "./NormalItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports